import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { CompanyModel } from "./internship-company-data.model";

export class CompanyGridParams extends GridPostParams {
    year: any = '2024';
  }
  export class CompanyGridModel extends CompanyModel {}
  
  export class CompanyListingModel extends GridModel<CompanyGridModel> {}